RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _, CompareData, Dashboard) {

    'use strict';

    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            instanceId: 'additional-auth-linkedin',
            widgetId: RivalIQ.enums.widgetTypes.ADDITIONAL_AUTHORIZATION,
            region: 'top',
            supportedExportFormats: [],
            props: {
                source: CompareData.sources.LINKEDIN
            }
        },
        {
            instanceId: 'section-followers',
            widgetId: widgetTypes.LI_INSIGHTS_FOLLOWERS,
            region: 'top-left'
        },
        {
            instanceId: 'profile-analytics',
            widgetId: RivalIQ.enums.widgetTypes.LI_INSIGHTS_PROFILE_ANALYTICS,
            region: 'top-right'
        },
        {
            instanceId: 'follower-locations',
            widgetId: widgetTypes.LI_INSIGHTS_FOLLOWER_LOCATIONS,
            region: 'middle-left'
        },
        {
            instanceId: 'follower-demographics',
            widgetId: widgetTypes.LI_INSIGHTS_FOLLOWER_DEMOGRAPHICS,
            region: 'middle-right'
        },
        {
            instanceId: 'post-impressions-per-reach',
            widgetId: widgetTypes.LI_INSIGHTS_POST_IMPRESSIONS_PER_REACH,
            region: 'bottom-left'
        },
        {
            instanceId: 'post-engagements',
            widgetId: widgetTypes.LI_INSIGHTS_POST_ENGAGEMENTS,
            region: 'bottom-right'
        }
    ];

    const oauthUrl = RivalIQ.channels.getOAuthUrl(CompareData.sources.LINKEDIN);
    const inactiveCompanyWarningWidget = {
        instanceId: 'insights-company-inactive2',
        widgetId: RivalIQ.enums.widgetTypes.LIMITATION,
        region: 'top',
        props: {
            type: 'warning',
            closeable: false,
            upsell: false,
            img: null,
            title: 'Inactive Company',
            description: `LinkedIn reported that this company is inactive. If you have recently reactivated it in LinkedIn, please click <a href="${oauthUrl}">here</a>.`
        }
    };

    const config = [
        [
            {
                name: 'top-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            },
            {
                name: 'top-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            }
        ],
        [
            {
                name: 'middle-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            },
            {
                name: 'middle-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            }
        ],
        [
            {
                name: 'bottom-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            },
            {
                name: 'bottom-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            }
        ]
    ];

    curations.LinkedInInsightsCuration = curations._BaseLinkedInInsightsCuration.extend({

        widgetsView: function () {
            return Dashboard.views.CurationLayout.extend({
                config: config
            });

        },

        exportWidgetsView: function () {
            return Dashboard.views.ExportWidgets.extend({
                childView: Dashboard.views.ExportLayout.extend({
                    config: config
                })
            });
        },

        buildConfiguration: function () {
            const me = this;

            let definitions = widgets;

            // TODO this will never be true b/c loadConfiguration is called
            // before the presence is loaded
            if (me.presence && me.presence.get('inactive_in_linked_in')) {
                definitions = [inactiveCompanyWarningWidget].concat(definitions);
                widgets.unshift(inactiveCompanyWarningWidget);
            }

            const config = {};

            definitions = _.map(definitions, function (definition) {
                definition = _.clone(definition);
                definition.props = _.defaults(definition.props || {}, config);

                return definition;
            });

            return new RivalIQ.apps.Dashboard.models.Configuration({
                definitions: definitions
            });
        },

        processProps: function (props) {
            return _.defaults({
                channel: RivalIQ.data.channels.get(RivalIQ.enums.sources.LINKEDIN).getChannel()
            }, props);
        }
    });

}, RivalIQ.data.CompareData, RivalIQ.apps.Dashboard);
